import tinycolor from 'tinycolor2'

import { ITableColumn } from '@makyoapp/makyo-sdk/models/Table'

import { Cell, ICell } from '.'

export interface IColorColumnSettings {
  colorTransparent: boolean
}

export interface IColorColumn extends ITableColumn {
  Settings: IColorColumnSettings
}

export interface IColorCell extends ICell {
  settings: IColorColumnSettings
}

/**
 * @todo make sure wether we should parsed invalid email or not
 */
export class ColorCell implements IColorCell {
  value: Cell
  settings: IColorColumnSettings

  constructor(value: Cell, settings: IColorColumnSettings) {
    this.settings = {
      colorTransparent: settings.colorTransparent,
    }
    this.value = this.getHexColorValue(value)
  }

  toString(): string {
    if (this.value === null || this.value === undefined || typeof this.value !== 'string') {
      return ''
    }
    return this.value.toString().toUpperCase()
  }

  toCell<T extends Cell>(newValue: T) {
    this.value = this.getHexColorValue(newValue)
    return this
  }

  private getHexColorValue(colorValue: Cell) {
    // Check if the value is empty or not a valid color string
    if (!colorValue || typeof colorValue !== 'string') {
      return ''
    }

    const isValid = tinycolor(colorValue).isValid()
    if (!isValid) return ''

    return this.settings.colorTransparent
      ? tinycolor(colorValue).toHex8String().toUpperCase()
      : tinycolor(colorValue).toHexString().toUpperCase()
  }
}
